import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { resourcePath } from '../../utils/helpers';
import './social-post.scss';
import { Image } from '../design-system/containers';
import DefaultTrans from './default-i18next-trans';

export const SocialPost = observer(({ socialPostData }) => {
    const { t } = useTranslation('assessment');

    const [imageZoomed, setIsImageZoomed] = React.useState(false);

    const handleImageClick = () => {
        setIsImageZoomed(!imageZoomed);
    };

    return (
        <>
            {socialPostData.type === 'linkedin' && (
                <div className={'post_linkedin'}>
                    <div className={'post_header'}>
                        <div className={'left'}>
                            <Image
                                src={resourcePath(
                                    socialPostData.human_profile_image
                                )}
                                alt={t('Profile')}
                            />
                        </div>
                        <div className={'right'}>
                            <h3>
                                {t(socialPostData.human_name)}{' '}
                                <span>
                                    {' '}
                                    • {t(socialPostData.human_connection)}
                                </span>
                            </h3>
                            <p>{t(socialPostData.human_subtitle)}</p>
                            <p>{t(socialPostData.age)}</p>
                        </div>
                    </div>
                    <div className={'post_main'}>
                        <div className={'post_text'}>
                            <DefaultTrans
                                translatedString={t(socialPostData.text)}
                            />
                        </div>
                        {socialPostData.imageZoom && (
                            <Image
                                src={resourcePath(socialPostData.image)}
                                alt={t('illustration')}
                                link
                                fullWidth
                                onClick={handleImageClick}
                            />
                        )}
                        {!socialPostData.imageZoom && socialPostData.image && (
                            <Image
                                src={resourcePath(socialPostData.image)}
                                alt={t('illustration')}
                                fullWidth
                            />
                        )}
                        <div className={'post_feedback'}>
                            {t(socialPostData.like_count)} •{' '}
                            {t(socialPostData.comment_count)} {t('Comments')}
                        </div>
                    </div>
                </div>
            )}
            {socialPostData.type === 'facebook' && (
                <div className={'post_facebook'}>
                    <div className={'post_header'}>
                        <div className={'left'}>
                            <Image
                                src={resourcePath(
                                    socialPostData.human_profile_image
                                )}
                                alt={t('Profile')}
                            />
                        </div>
                        <div className={'right'}>
                            <h3>
                                {t(socialPostData.human_name)}{' '}
                                <span>
                                    {' '}
                                    • {t(socialPostData.human_feeling)}
                                </span>
                            </h3>
                            <p>{t(socialPostData.human_subtitle)}</p>
                            <p>{t(socialPostData.age)}</p>
                        </div>
                    </div>
                    <div className={'post_main'}>
                        <div className={'post_text'}>
                            <DefaultTrans
                                translatedString={t(socialPostData.text)}
                            />
                        </div>
                        {socialPostData.imageZoom && (
                            <Image
                                src={resourcePath(socialPostData.image)}
                                alt={t('illustration')}
                                link
                                fullWidth
                                onClick={handleImageClick}
                            />
                        )}
                        {!socialPostData.imageZoom && socialPostData.image && (
                            <Image
                                src={resourcePath(socialPostData.image)}
                                alt={t('illustration')}
                                fullWidth
                            />
                        )}
                        <div className={'post_feedback facebook'}>
                            <div className={'left'}>
                                {t(socialPostData.like_count)}
                            </div>
                            <div className={'right'}>
                                {t(socialPostData.comment_count)}{' '}
                                {t('Comments')}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div
                className="image-zoomed"
                onClick={handleImageClick}
                style={{
                    opacity: imageZoomed ? '1' : '0',
                    visibility: imageZoomed ? 'visible' : 'hidden',
                }}
            >
                <Image
                    src={resourcePath(socialPostData.imageZoom)}
                    alt={t('illustration')}
                    onClick={handleImageClick}
                />
            </div>
        </>
    );
});
